var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.wedSiteInfo &&
    (!_vm.wedSiteInfo.parceria ||
      _vm.wedSiteInfo.parceria === 'assessoriavip_sem_rsvp')
  )?_c('layout',{attrs:{"titlePage":"Convidados (RSVP)"}},[_c('HeaderGuests'),_c('ListGuests'),_c('ModalCreateRsvpInvites')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }